// removed by extract-text-webpack-plugin
module.exports = {"container":"_2s8DT","isLoading":"_3x5i7"};


//////////////////
// WEBPACK FOOTER
// ./app/components/text-editor/text-editor-video-embed.scss
// module id = 763
// module chunks = 3 4 5 6 7